import React from "react";
import { MapPin, Clock, Camera, PenLine, ShieldCheck, BellRing } from "lucide-react";

const MOCKUP = "https://static.prod-images.emergentagent.com/jobs/58b0a64d-2d51-4608-b7c2-5645fa033b5b/images/81d61a3dab584b82bda0e4c41225b36e1da1660954619d570151c75a7e68b455.jpeg";

const points = [
  { icon: MapPin, title: "Pointage géolocalisé", desc: "Nos intervenants pointent le début et la fin de chaque prestation avec leur position GPS." },
  { icon: Clock, title: "Horaires horodatés", desc: "Chaque intervention est datée précisément : vous savez exactement quand nous sommes passés." },
  { icon: Camera, title: "Photos avant / après", desc: "Des preuves visuelles de la qualité du travail réalisé, accessibles en un clic." },
  { icon: PenLine, title: "Signature sur place", desc: "Validation de la prestation par votre équipe, directement depuis l'application." },
];

const GpsTracking = () => {
  return (
    <section className="py-20 md:py-28 bg-neutral-950 text-white overflow-hidden" data-testid="gps-tracking-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4 flex items-center gap-2">
            <ShieldCheck size={15} /> Suivi sécurisé & transparent
          </p>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl leading-tight">
            Chaque prestation <span className="text-brand">tracée et prouvée</span>
          </h2>
          <p className="text-neutral-400 text-lg mt-5 max-w-lg">
            Nos collaborateurs pointent le début et la fin de chaque intervention via une application dédiée,
            avec géolocalisation GPS. Vous recevez un récapitulatif complet : la garantie d'un service
            fiable, ponctuel et vérifiable.
          </p>

          <div className="grid sm:grid-cols-2 gap-5 mt-9">
            {points.map((p) => (
              <div key={p.title} className="flex gap-3">
                <div className="bg-brand/15 text-brand rounded-lg p-2.5 h-fit"><p.icon size={18} /></div>
                <div>
                  <h3 className="font-semibold text-white">{p.title}</h3>
                  <p className="text-sm text-neutral-400 mt-0.5">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-9 inline-flex items-center gap-2.5 bg-brand/10 border border-brand/30 rounded-full px-4 py-2 text-sm text-brand font-medium">
            <BellRing size={15} /> Récapitulatif automatique envoyé au client après chaque passage
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-6 bg-brand/20 blur-3xl rounded-full opacity-40" aria-hidden="true" />
          <img src={MOCKUP} alt="Application de pointage GPS PTITSERVICES-PRO"
            className="relative w-full rounded-2xl border border-neutral-800 shadow-2xl" />
        </div>
      </div>
    </section>
  );
};

export default GpsTracking;
